import { combineReducers } from 'redux';
import auth from './auth';
import retailer from './retailer';
import productsDropship from './productsDropship';
import productsReplenish from './productsReplenish';
import acceptedInvitationRetailers from './acceptedInvitationRetailers';
import pageFilters from './pageFilters';
import brandOrders from './brandOrders';
import approvedRetailers from './approvedRetailers';
import role from './roles';
import permissions from './permissions';
import replenishProducts from './replenishProducts';
import retailerProducts from './retailerProducts';
import dropshipProducts from './dropshipProducts';
import supplierInventory from './supplierInventory';
import searchAllRetailers from './searchAllRetailers';
import alert from './alert';
import adminBrands from './adminBrands';
import adminAccountInfo from './adminAccountInfo';
import adminStores from './adminStores';
import dropshipOrders from './dropshipOrders';
import signup from './signup';
import cart from './cart';
import supplierReorderRequest from './supplierReorderRequest';
import adminUsers from './adminUsers';
import supplierAdminUsers from './supplierAdminUsers';
import checkPermissions from './checkPermissions';
import activation from './activation';
import retailerOrders from './retailerOrders';
import productFilters from './productFilters';
import systemProperties from './systemProperties';
import warehouses from './warehouses';
import resetPassword from './resetPassword';
import channels from './channels';
import historyLog from './historyLog';
import shopify from './shopify';
import featureFlags from './featureFlags';
import woocommerce from './woocommerce';
import pricings from './pricings';
import accountIdConfig from './accountIdConfig';
import productsFeeds from './productsFeeds';
import analytics from './analytics';
import reportsManager from './reportsManager';
import pageLayout from './pageLayout';
import { aiChatbotReducer } from './aiChatbot';
import operators from './operators';
import integrations from './integrations';

const rootReducer = combineReducers({
  auth,
  retailer,
  productsDropship,
  productsReplenish,
  acceptedInvitationRetailers,
  pageFilters,
  brandOrders,
  approvedRetailers,
  role,
  permissions,
  replenishProducts,
  retailerProducts,
  dropshipProducts,
  supplierInventory,
  searchAllRetailers,
  alert,
  adminBrands,
  adminAccountInfo,
  adminStores,
  dropshipOrders,
  signup,
  cart,
  adminUsers,
  supplierAdminUsers,
  checkPermissions,
  activation,
  retailerOrders,
  productFilters,
  systemProperties,
  warehouses,
  resetPassword,
  channels,
  historyLog,
  shopify,
  featureFlags,
  supplierReorderRequest,
  woocommerce,
  pricings,
  accountIdConfig,
  productsFeeds,
  analytics,
  reportsManager,
  pageLayout,
  aiChatbot: aiChatbotReducer,
  operators,
  integrations,
});

export default rootReducer;
